import MessagesDisplay from "../../Messages/MessagesDisplay";

// use pageData context
import { usePageData } from '../../../contexts/PageData';

const Messages = () => {
  const { data = {} } = usePageData();
  return (
    <MessagesDisplay includeHeader={false} customer_id={data?.customer_id} resource="service_tickets" resource_id={data?.service_ticket_id} />
  );
};

export default Messages;